export default __webpack_public_path__ + "static/product-2-desktop-a5e243fadde3b5f30fb3fbe3ddc49295.png";